// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_T06","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_lsG FallbackBulkDownloadUpsellModalControl-cls1_T06"};